/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_View_ModernInputs */

const en_orders_view_modern = /** @type {(inputs: Orders_View_ModernInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern`)
};

const es_orders_view_modern = /** @type {(inputs: Orders_View_ModernInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderno`)
};

/**
* | output |
* | --- |
* | "Modern" |
*
* @param {Orders_View_ModernInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_view_modern = /** @type {((inputs?: Orders_View_ModernInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_View_ModernInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_view_modern(inputs)
	return es_orders_view_modern(inputs)
});